<template>
  <div class="wrapper-login z-10" v-on:keyup.enter="loginForgot">
    <div class="card card-login">
      <div class="login-header gradient-donapp">
        <i class="back material-icons"  v-on:click="goToDonappWebsite">home</i>
        <p v-if="false" class="signup clickable">{{$t('labels.signup')}}</p>
        <div class="overlay-logo"></div>
        <img class="donapp-logo" src="../../assets/square-logo.png"/>
      </div>
      <div class="card-content">
        <popup-input :class="{'email-input': true, 'with-forgot': forgot}"  v-model="email" material-icon="email" label="Email" type="email" name="email" :validation="validation.email" />
        <popup-input :class="{'password-input': true, 'with-forgot': forgot}" v-model="password" material-icon="lock_outline" name="password" label="Password" type="password" :validation="validation.password" />
      </div>
      <div class="text-center mb10">
        <Button :action="loginForgot" :text="forgot ? $t('labels.send') : $t('labels.login')" :disabled="$validator.errors.items.length > 0 || loading"/>
      </div>
      <div class="footer-label">
        <span class="forgot-button" @click="forgot = !forgot">{{ forgot ? $t('labels.back') : $t('labels.forgot_password')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import PopupInput from '@/components/shared/inputs/PopupInput'
import Button from '@/components/shared/buttons/Button'

export default {
  name: 'login',
  components: {
    Button,
    PopupInput
  },
  $_veeValidate: {
    validator: 'new' // give me a new validator each time.
  },
  data() {
    return {
      email: '', // merchant
      password: '',
      rememberMe: false,
      hasToken: false,
      forgot: false,
      loading: false
    }
  },
  mounted: async function() {
    this.logout()
    let accessToken = localStorage.getItem('token')
    if (accessToken !== 'undefined') {
      this.getUser(accessToken)
    }
  },
  methods: {
    goToDonappWebsite: function() {
      window.open('https://www.donapp.it', '_blank')
    },
    loginForgot: async function() {
      try {
        this.loading = true
        const allOK = await this.$validator.validateAll()
        if (allOK) {
          if (this.forgot) {
            await this.forgotPassword({ email: this.email })
            // this.email = ''
          } else await this.signIn({ email: this.email, password: this.password })
        }
        this.loading = false
      } catch (error) {
        this.$toasted.error(this.$i18n.t('errors.something_wrong'))
      }
    },
    getUser: function(refreshToken) {
      this.getMe({ refreshToken })
    },
    ...mapActions({
      signIn: 'signIn',
      getMe: 'getMe',
      forgotPassword: 'forgotPassword'
    }),
    ...mapMutations({
      logout: 'logout'
    })
  },
  computed: {
    validation: function() {
      return {
        email: 'required|email',
        password: this.forgot ? '' : 'required'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/config.scss';
.login-header {
  position: relative;
  min-height: 160px;
  text-align: center;
  padding: 22px 16px;
  border-radius: 16px 16px 0px 0px;
}

.login-header .header-title {
  font-size: 29px;
  font-weight: 700;
  color: $white;
  text-transform: uppercase;
}

.card-content {
  padding: 0 16px 14px;
  margin-top: -48px;
  position: relative;
  z-index: 2;
}

.wrapper-full-page {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
}

.card-title {
  font-weight: bold;
}

.card {
  border-radius: 16px;
  width: 352px;
  margin: 0 auto;
  z-index: 1;
}

.footer-label {
  text-align: center;
  padding-bottom: 10px;
}

.forgot-button {
  font-size: 10px;
  text-decoration: underline;
  text-decoration-color: $grey;
  cursor: pointer;
}

.remember-me {
  display: flex;
  align-items: center;
}

.login-header .back {
  left: 16px;
  cursor: pointer;
  font-weight: 100;
  width: 20px;
}

.login-header .signup {
  right: 24px;
  width: 55px;
  text-transform: uppercase;
}

.donapp-logo {
  margin: 26px auto;
  width: 150px;
}

.login-header .back,
.login-header .signup {
  position: absolute;
  top: 24px;
  z-index: 11;
  color: #ffffff;
}

.wrapper-login {
  text-align: center;
  padding-top: 32px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.password-input {
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease, margin-top 0.3s ease, margin-bottom 0.3s;
}

.email-input {
  transition: margin-bottom 0.3s;
}

.password-input.with-forgot {
  max-height: 0px;
  padding: 0px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.email-input.with-forgot {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Login.vue